<template>
	<div v-loading="loading">
		<div class="app-container">
			<div class="el-title">严重违法信息</div>
			<el-table v-loading="loading" border :data="yzwfxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50"/>
				<el-table-column label="列入时间" align="center" prop="abntime">
					<template slot-scope="scope">
							{{ parseTime(scope.row.abntime, '{y}年{m}月{d}日') }}
						</template>
				</el-table-column>
				<el-table-column label="列入原因"   align="center"  prop ="serillreaCn"/>
				<el-table-column label="列入机关"   align="center"  prop ="decorgCn"/>
		 
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="getYzwfxxList()()" />
		 
		</div>
	</div>
</template>

<script>
	import {
		listYzwfxx
	} from "@/api/qygzs/yqyd";
 
	export default {
		name: 'Yzwfqyxx',		 
		props: {
			//企业内部序号
			pripid: {
				type: String,
				require: true
			}
		},
		watch: {
			pripid(newValue, oldValue) {
				this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {
				//严重违法信息列表
				yzwfxxList: [],			 
				 
				loading: false,
				// 选中数组
				ids: [],
				// 非单个禁用
				single: true,
				// 非多个禁用
				multiple: true,
				//【异常名录信息列表】总条数
				total: 0,
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					pripid: undefined,
				},
			 
				 
			}
		},
		created() {
			this.init();
		 
		},
		methods: {
			init() {
				this.loading = true;
				this.getYzwfxxList();
			},
			//获取严重违法信息列表
			getYzwfxxList() {
				this.loading = true;
				this.queryParams.pripid = this.pripid;
				listYzwfxx(this.queryParams).then(response => {
					this.yzwfxxList = response.rows;
					this.total = response.total;
					this.loading = false;
				});
			},
			 
		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
